export const SarvaMark = ({ className = "w-9 h-9", tone = "gold" }) => (
  <img
    src={`/brand/mark-${tone === "forest" ? "dark" : "white"}.png`}
    alt=""
    aria-hidden="true"
    className={`${className} object-contain`}
    draggable="false"
  />
);

export const SarvaLogo = ({ dark = true, className = "" }) => (
  <span className={`inline-flex items-center gap-3 ${className}`}>
    <img src="/brand/mark-white.png" alt="" aria-hidden="true" className="h-9 w-9 object-contain shrink-0" draggable="false" />
    <img
      src={`/brand/wordmark-${dark ? "white" : "dark"}.png`}
      alt="SarvaRitam™"
      className="h-[22px] w-auto object-contain"
      draggable="false"
    />
  </span>
);
